import { Spinner } from '@chakra-ui/react';
import { faCloudArrowDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useToast } from '@morressier/alembic';
import { useState } from 'react';
import { fetchSubmissionIntegrityReportsDownload } from 'src/api/queries';
import ProtectedActionButton from 'src/components/ProtectedAction/Button';
type Props = {
  submissionId: string;
  submissionContextId: string;
  currentState: string;
  runId: string;
  disable: boolean;
};
const DownloadReport: React.FC<Props> = ({
  submissionId,
  submissionContextId,
  currentState,
  disable,
  runId
}) => {
  const [downloadReportsLoading, setDownloadReportsLoading] =
    useState<boolean>(false);
  const toast = useToast();
  const HandleDownloadReport = async () => {
    try {
      setDownloadReportsLoading(true);
      const ReportDownloadData = await fetchSubmissionIntegrityReportsDownload(
        submissionId,
        runId
      );
      const disposition = ReportDownloadData.headers['content-disposition'];
      const filename = disposition
        ? disposition.split('filename=')[1]?.replace(/"/g, '')
        : 'report.pdf';
      const blob = new Blob([ReportDownloadData.data], {
        type: 'application/pdf'
      });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(link.href);
    } catch (error) {
      toast({
        variant: 'error',
        title: 'Download Failed',
        description:
          'An error occurred during the download Please try again later.'
      });
    } finally {
      setDownloadReportsLoading(false);
    }
  };
  return (
    <>
      <ProtectedActionButton
        relation="decision_maker"
        entityType="journal_phase"
        entityId={`${submissionContextId}_${currentState}`}
        size="context"
        variant="primary"
        as="text"
        textStyle={'textContext'}
        onClick={HandleDownloadReport}
        disabled={disable}
      >
        <FontAwesomeIcon icon={faCloudArrowDown} /> Download Report
        {downloadReportsLoading && <Spinner />}
      </ProtectedActionButton>
    </>
  );
};

export default DownloadReport;
